import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Icon,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";
import Grids from "../../../components/grids";
import AuthContext from "../../../contexts/authContext";
import axiosInstance from "../../../api/axios";
import AddAsset from "../../../components/modals/addasset";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ViewAsset from "../../../components/modals/viewasset";
import AddDesign from "../../../components/modals/adddesign";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, FormLabel, Modal, Option, Select } from "@mui/joy";

const Assets = () => {
  const [openAsset, setOpenAsset] = useState(false);
  const { userData, setRefresh } = useContext(AuthContext);
  const [openViewAsset, setOpenViewAsset] = useState(false);
  const [assetId, setAssetId] = useState("");
  const [openDesign, setOpenDesign] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const role = localStorage.getItem("role");
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updateText, setUpdateText] = useState("");
  const [designId, setDesignId] = useState("");
  const openMenu = Boolean(anchorEl);

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 80,
      flex: 0.5,
    },
    {
      field: "companyName",
      headerName: "Company Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "Designs",
      headerName: "Designs",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      maxWidth: 120,
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      flex: 1,
      // renderCell: (params) => (
      //   <Box sx={{ display: "flex", justifyContent: "center" }}>
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleviewAsset(params.row._id)}
      //     >
      //       <Icon>
      //         <VisibilityIcon />
      //       </Icon>
      //     </IconButton>

      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleEditAsset(params.row._id)}
      //     >
      //       <Icon>
      //         <EditIcon />
      //       </Icon>
      //     </IconButton>
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleAddDesign(params.row._id)}
      //     >
      //       {/* implement tooltip show on top */}
      //       <Tooltip title="Add Design" placement="top">
      //         <Icon>
      //           <AddIcon sx={{ fontWeight: "bold" }} fontSize="medium" />
      //         </Icon>
      //       </Tooltip>
      //     </IconButton>
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": { backgroundColor: "#800001", color: "#fff" },
      //       }}
      //       onClick={() => handleDeleteAsset(params.row._id)}
      //     >
      //       <Icon>
      //         <DeleteIcon />
      //       </Icon>
      //     </IconButton>
      //   </Box>
      // ),
      renderCell: (params) => (
        <IconButton
          onClick={(e) => handleOpenMenu(e, params.row._id)}
          sx={{ color: "#800001" }}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  const rows =
    userData?.assets
      ?.filter((asset) => asset.status !== "erased")
      .map((asset, idx) => ({
        id: idx + 1,
        _id: asset._id,
        companyName: asset.companyName,
        email: asset.email,
        mobile: asset.mobile,
        address: asset.address,
        Designs:
          asset.designs?.filter((design) => design.status === "active")
            .length || 0,
      })) || [];

  const handleviewAsset = (id) => {
    setOpenViewAsset(true);
    setAssetId(id);
  };

  const handleAddDesign = (id) => {
    setAssetId(id);
    setOpenDesign(true);
  };

  const handleEditAsset = (id) => {
    setEditMode(true);
    setAssetId(id);
    setOpenAsset(true);
  };
  const handleAddUpdate = (id) => {
    setAssetId(id);
    setUpdateText("");
    setOpenUpdateModal(true);
  };

  const handleDeleteAsset = async (id) => {
    if (!window.confirm("Do you want to delete this asset?")) return;

    try {
      const res = await axiosInstance.post(`/asset/delete/${id}`);
      if (res.status === 200) {
        toast.success("Asset deleted successfully");
        setRefresh(true);
      } else {
        toast.error("Failed to delete asset");
      }
    } catch {
      toast.error("An error occurred while deleting");
    }
  };

  const handleOpenMenu = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  return (
    <>
      <Typography
        variant="h5"
        color="#800001"
        sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
      >
        Assets
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          justifyContent: "space-between",
          padding: "10px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Button
          onClick={() => setOpenAsset(true)}
          sx={{
            display: "flex",
            gap: 1,
            backgroundColor: "#800001",
            color: "#fff",
            padding: "8px 16px",
          }}
          startIcon={<AddIcon />}
        >
          Add Company
        </Button>
      </Box>

      <Box sx={{ width: { xs: "95vw", sm: "81vw" } }}>
        <Grids columns={columns} rows={rows} />
      </Box>
      {/* Add Asset Modal */}
      <AddAsset
        openAsset={openAsset}
        setOpenAsset={setOpenAsset}
        editMode={editMode}
        setEditMode={setEditMode}
        assetId={assetId}
        setAssetId={setAssetId}
      />
      {/* View Asset Modal */}
      <ViewAsset
        openViewAsset={openViewAsset}
        setOpenViewAsset={setOpenViewAsset}
        setAssetId={setAssetId}
        assetId={assetId}
      />
      {/* Design Modal */}
      <AddDesign
        openDesign={openDesign}
        setOpenDesign={setOpenDesign}
        setAssetId={setAssetId}
        assetId={assetId}
      />
      {/* Update Modal */}
      <Modal open={openUpdateModal} onClose={() => setOpenUpdateModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 300, sm: 400 },
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography sx={{ mb: 1, fontWeight: 600 }}>Add Update</Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControl sx={{ flex: 1 }}>
              <FormLabel>Select Design</FormLabel>

              <Select value={designId} onChange={(e, val) => setDesignId(val)}>
                {userData?.assets
                  ?.find((ast) => ast._id === assetId)
                  ?.designs?.map((design) => (
                    <Option key={design._id} value={design._id}>
                      {design.designId ?? design._id.slice(-4).toUpperCase()} -{" "}
                      {design.designName || "Unnamed Design"}
                    </Option>
                  ))}
              </Select>
            </FormControl>

            <TextField
              multiline
              rows={4}
              fullWidth
              value={updateText}
              sx={{ bgcolor: "#fff" }}
              onChange={(e) => setUpdateText(e.target.value)}
              placeholder="Enter update notes..."
            />
          </Box>

          <Button
            sx={{
              mt: 2,
              backgroundColor: "#800001",
              color: "white",
              width: "100%",
              "&:hover": { backgroundColor: "#a00001" },
            }}
            onClick={async () => {
              await axiosInstance.post(`/designs/addupdates/${designId}`, {
                updates: updateText,
                designId: designId,
                added_by: localStorage.getItem("userId"),
              });
              toast.success("Updates added");
              setRefresh(true);
              setOpenUpdateModal(false);
            }}
          >
            Save Updates
          </Button>
        </Box>
      </Modal>
      {/* Menu Dropdown */}
      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleviewAsset(selectedRowId);
            handleCloseMenu();
          }}
        >
          <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
          View
        </MenuItem>

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleEditAsset(selectedRowId);
              handleCloseMenu();
            }}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            Edit
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            handleAddDesign(selectedRowId);
            handleCloseMenu();
          }}
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
        >
          <AddIcon fontSize="small" style={{ marginRight: 8 }} />
          Add Design
        </MenuItem>
        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleAddUpdate(selectedRowId);
            handleCloseMenu();
          }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          Add Updates
        </MenuItem>

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleDeleteAsset(selectedRowId);
              handleCloseMenu();
            }}
          >
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Assets;
